import type { CabinetLanguage } from '@sirius/contracts/admin'
import { CABINET_LANGUAGES } from '@sirius/contracts/admin'
import type { TFunction } from 'i18next'

/**
 * Each language a cabinet may be set to by its own name, as its players read
 * it. A language the contract adds fails the typecheck until it is named here.
 */
export const LANGUAGE_NAMES: Record<CabinetLanguage, string> = {
  en: 'English',
  ru: 'Русский',
  tr: 'Türkçe',
}

/**
 * The language options of an `InheritableSelect` (which puts "Use default"
 * first), in the contract's order.
 */
export const LANGUAGE_OPTIONS: readonly {
  value: CabinetLanguage
  label: string
}[] = CABINET_LANGUAGES.map((code) => ({
  value: code,
  label: LANGUAGE_NAMES[code],
}))

export function isCabinetLanguage(value: unknown): value is CabinetLanguage {
  return (CABINET_LANGUAGES as readonly unknown[]).includes(value)
}

/**
 * The show page's Language: its name, or "Default (Русский)" for none, with
 * the language it inherits (its tenant's default language, else the
 * platform's).
 */
export function cabinetLanguageLabel(
  language: CabinetLanguage | null,
  inherited: CabinetLanguage | null | undefined,
  t: TFunction,
): string {
  if (language !== null) {
    return LANGUAGE_NAMES[language]
  }
  return inherited === null || inherited === undefined
    ? t('shell.common.default')
    : t('shell.common.defaultWith', {
        name: LANGUAGE_NAMES[inherited],
      })
}
